<template>
  <div class="app">
    <hospital-select @selected="selectHospital"></hospital-select>
    <voucher-select
      :list="voucherList"
      @selected="selectVoucher"
    ></voucher-select>
    <div class="more">
      <span>此处展示近三个月的历史记录</span>
      <button type="button" class="btn-ok" @click="loadMore()">更多</button>
    </div>
    <div class="history" v-if="isChoose">
      <div class="time">请选择查询时间段</div>
      <div class="history-more">
        <div class="option" @click="setStartDate">{{ startDate }}</div>
        <span></span>
        <div class="option" @click="setEndDate">{{ endDate }}</div>
        <button class="btn-ok" @click="chooseDate()">确定</button>
      </div>
    </div>
    <div
      class="dept-list"
      v-for="(item, index) in deptList"
      v-if="deptList[index].recipeType !== '4'"
    >
      <div class="dept-name">{{ item.deptName }}</div>
      <div class="dept-doctor" @click="goDetails(index)">
        <div>门诊医生:&nbsp;&nbsp;{{ item.doctName }}</div>
        <div>开单时间:{{ makeTime[index] }}</div>
      </div>
    </div>
    <no-record
      id="myregister-norecord"
      :condition="deptList"
      tips="抱歉，没有处方记录"
    ></no-record>
  </div>
</template>

<script>
import queryVoucher from 'voucher.service'
import HospitalSelect from 'HospitalSelect'
import VoucherSelect from 'VoucherSelect'
import queryFunList from 'queryFunList.service'
import NoRecord from 'NoRecord'
export default {
  components: {
    HospitalSelect,
    NoRecord,
    VoucherSelect
  },
  beforeRouteLeave (to, from, next) {
    if (to.name == 'PrescriptionDetail') {
      if (!from.meta.keepAlive) {
        from.meta.keepAlive = true
      }
      next()
    } else {
      from.meta.keepAlive = false
      to.meta.keepAlive = false
      this.$destroy()
      next()
    }
  },
  data () {
    return {
      voucher: {
        cardNo: '',
        cardType: '',
        holderName: '',
        hospitalName: ''
      },
      voucherList: [],
      deptList: [],
      isChoose: false,
      startDate: '',
      endDate: '',
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      makeTime: [],
    }
  },
  mounted () {
    this.messagePush();
    this.$router.afterEach((to, from) => {
      if (from.name == 'index' && to.name == 'MyPrescription') {
        let isRefresh = sessionStorage.getItem('isRefresh')
        if (isRefresh == '0') {
          sessionStorage.setItem('isRefresh', null)
          window.location.reload()
        } else {
          sessionStorage.setItem('isRefresh', 0)
        }
      } else if (from.name == 'MyPrescription' && to.name == 'index') {
        sessionStorage.setItem('isRefresh', 0)
      }
    });
  },
  methods: {
    messagePush () {
      this.formatDatePicker()
      var query = this.$router.currentRoute.query;
      //区分消息推送和正常页面跳转
      if (query.cardNo) {
        //设置医院消息头和localStorage
        const hospital = {
          "hospitalId": query.hospitalId,
          "hospitalIndex": query.hospitalIndex,
          "hospitalName": query.hospitalName,
          "hospitalType": query.hospitalType
        };
        localStorage.selectedHospital = JSON.stringify(hospital);
        window.http.headers.common['hospitalId'] = hospital.hospitalId;
      }
      this.loadVouchers();
    },
    loadMore () {
      this.isChoose = !this.isChoose
    },
    //默认查询三个月
    formatDatePicker () {
      var dateOb = new Date()
      var year = dateOb.getFullYear()
      var oneMonth = dateOb.getMonth() - 3
      var twoMonth = dateOb.getMonth()
      var day = dateOb.getDate()
      var firstDay = new Date(year, oneMonth, day)
      var lastDay = new Date(year, twoMonth, day);
      this.startDate = firstDay.format('yyyy-MM-01')
      this.endDate = lastDay.format('yyyy-MM-dd')
    },
    loadVouchers () {
      // 获取用户就诊凭证
      queryVoucher.getVoucherList().then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }
        const data = res.data;
        if (data.length === 0) {
          this.$utils.alert('请先绑定诊疗卡');
          return;
        }
        this.voucherList = data;
        // 首次进入，默认第一张诊疗卡信息
        this.voucher = JSON.parse(JSON.stringify(this.voucherList[0]));

        // 保存默认卡信息
        this.$store.commit('updateParam', {
          namespace: 'mypay',
          voucher: this.voucher,
        });
        this.refresh();
      });
    },
    loadDetails () {
      queryFunList.getReceipe({
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo,
        startDate: this.startDate,
        endDate: this.endDate,
      }).then((res) => {
        this.deptList = res.data.visitRecords || []
        for (var i = 0; i < this.deptList.length; i++) {
          if (this.deptList[i].recipes.length !== 0) {
            if (this.deptList[i].recipes[0].recipeTime) {
              let recipeTime = this.deptList[i].recipes[0].recipeTime
              let dateObject = new Date(recipeTime.replace(/-/g, '/'))
              let week = dateObject.getDay()
              this.makeTime[i] = dateObject.format('yyyy/MM/dd hh:mm').split(' ').join(' ' + this.weekday[week] + ' ')
            } else {
              this.makeTime[i] = ''
            }
          } else {
            this.makeTime[i] = ''
          }
        }
      })
    },
    refresh () {
      //处理初始进入微信的未选医院情况
      if (typeof (http.headers.common['hospitalId']) == "undefined") {
        this.$utils.alert("请选择医院");
        return
      }
      //处理未绑定就诊凭证
      if (!this.voucher.cardType || !this.voucher.cardNo) {
        return this.$utils.alert('请先绑定诊疗卡')
      }
      this.loadDetails()
    },
    //选择就诊凭证
    selectVoucher (v) {
      this.voucher = v;

      //保存默认卡信息
      this.$store.commit('updateParam', {
        namespace: 'mypay',
        voucher: v
      });
      //加载默认卡的就诊记录列表
      this.refresh();
    },
    //选择医院
    selectHospital (v) {
      this.voucher.hospitalName = v.hospitalName;
      this.refresh();
    },
    setStartDate () {
      const today = new Date()
      var maxDate = today.format('yyyy-MM-dd')
      today.setMonth(today.getMonth() - 12)
      var minDate = today.format('yyyy-MM-dd')
      this.$picker.show({
        type: 'datePicker',
        date: this.startDate,  //初始化时间
        endTime: maxDate,  //截至时间
        startTime: minDate,  //开始时间
        onOk: (e) => {
          //格式化成统一格式
          var newDate = new Date(e.replace(/-/g, "/"))
          this.startDate = newDate.format('yyyy-MM-dd')
        }
      });
    },
    setEndDate () {
      const today = new Date()
      var maxDate = today.format('yyyy-MM-dd')
      today.setMonth(today.getMonth() - 12)
      var minDate = today.format('yyyy-MM-dd')
      this.$picker.show({
        type: 'datePicker',
        date: this.endDate,  //初始化时间
        endTime: maxDate,  //截至时间
        startTime: minDate,  //开始时间
        onOk: (e) => {
          //格式化成统一格式
          var newDate = new Date(e.replace(/-/g, "/"))
          this.endDate = newDate.format('yyyy-MM-dd')
        },
      })
    },
    goDetails (index) {
      localStorage.setItem('deptList', JSON.stringify(this.deptList[index]))
      this.$router.push({
        name: 'PrescriptionDetail',
        query: {
          holderName: this.voucher.holderName,
          cardNo: this.voucher.cardNo,
          hospitalName: this.voucher.hospitalName,
          makeTime: this.makeTime[index]
        }
      });
    },
    chooseDate () {
      var start = new Date(this.startDate.replace(/-/g, '/'))
      var end = new Date(this.endDate.replace(/-/g, '/'))
      if (start.getTime() > end.getTime()) {
        this.$utils.alert('查询时间不正确')
        return
      }
      this.loadDetails()
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../static/sass/_variable.scss";
.app {
  background-color: #eff3f6;
  .more {
    position: relative;
    height: 1.5rem;
    line-height: 1.5rem;
    text-align: center;
    font-size: 0.65rem;
    .btn-ok {
      position: absolute;
      top: 0.45rem;
      right: 0.2rem;
      width: 1.5rem;
      height: 0.7rem;
      font-size: 0.35rem;
    }
  }
  .history {
    height: 2.2rem;
    .time {
      height: 1rem;
      line-height: 1rem;
      padding-left: 0.5rem;
      border-top: 1px solid #e2e6e9;
      font-size: 0.35rem;
    }
    .history-more {
      position: relative;
      .option {
        text-align: center;
        width: 2.3rem;
        float: left;
        height: 0.7rem;
        line-height: 0.75rem;
        border: 1px solid $main-style-color;
        border-radius: 0.25rem;
        padding-left: 0.7rem;
        padding-right: 0.7rem;
        color: $main-style-color;
        position: relative;
        font-size: 0.35rem;
        &:before {
          position: absolute;
          content: "";
          height: 0.4rem;
          width: 0.38rem;
          top: 0.15rem;
          left: 0.2rem;
          background-image: url(../../../static/img/icon-calendar.png);
          background-size: 100% 100%;
        }
        &:after {
          position: absolute;
          content: "";
          height: 0.2rem;
          width: 0.3rem;
          right: 0.2rem;
          top: 0.25rem;
          background-image: url(../../../static/img/more_blue_dwon.png);
          background-size: 100% 100%;
        }
        &:nth-child(1) {
          margin-left: 0.25rem;
        }
      }
      span {
        float: left;
        width: 0.2rem;
        border: 1px solid $main-style-color;
        margin: 0.4rem 0.1rem 0 0.1rem;
      }
      .btn-ok {
        top: 0.45rem;
        right: 0.2rem;
        width: 1.5rem;
        height: 0.7rem;
        font-size: 0.35rem;
        float: right;
        margin-right: 0.1rem;
      }
    }
  }
  .dept-list {
    background-color: #fff;
    margin-bottom: 0.5rem;
    .dept-name {
      padding: 0.35rem 0;
      padding-left: 0.5rem;
      border-bottom: 1px solid #eff3f6;
    }
    .dept-doctor {
      padding: 0.3rem 0.5rem;
      color: #999999;
      div {
        padding: 0.2rem 0;
      }
      div:nth-child(1) {
        position: relative;
      }
      div:nth-child(1):before {
        position: absolute;
        content: "";
        width: 0.2rem;
        height: 0.4rem;
        top: 50%;
        right: 0;
        margin-top: 0.3rem;
        background: url(../../../static/img/more-arrow.png) no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// MyPrescription.vue?1d5078ad